<template>
    <div style="overflow-x: hidden;overflow-y: auto; height: 100%;">
        <div class="page_header">
            <span class="page_title">{{ $t('maintenanceReminder.维保提醒') }}</span>
            <el-form :inline="true" :model="searchForm" size="small" style="flex:1;text-align: right;">
                <el-form-item :label="$t('maintenanceReminder.车型')">
                    <el-input v-model="searchForm.vehicleModel" :placeholder="$t('maintenanceReminder.请输入车型')"
                        clearable></el-input>

                </el-form-item>
                <el-form-item :label="$t('maintenanceReminder.阅读状态')">
                    <el-select v-model="searchForm.readStatus" :placeholder="$t('maintenanceReminder.请选择阅读状态')">
                        <el-option :label="$t('maintenanceReminder.全部')" value="-1"></el-option>
                        <el-option :label="$t('maintenanceReminder.已阅')" value="1"></el-option>
                        <el-option :label="$t('maintenanceReminder.未阅')" value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleSearch">{{ $t('public.query') }}</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" plain @click="exportData">{{ $t('public.export') }}</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="batchMarkAsRead" :disabled="selectedRows.length === 0">
                        {{ $t('maintenanceReminder.批量设置为已读') }}
                    </el-button>
                </el-form-item>
            </el-form>
        </div>

        <!-- 列表区域 -->
        <div class="list-container">
            <!-- 数据表格 -->
            <el-card class="data-card">
                <el-table :data="tableData" style="width: 100%" border v-loading="loading"
                    @row-dblclick="showDetailPage" @selection-change="handleSelectionChange">
                    <el-table-column type="selection" align="center" width="55"></el-table-column>
                    <el-table-column type="index" :label="$t('public.index')" width="60"
                        align="center"></el-table-column>
                    <el-table-column prop="CarNo" :label="$t('maintenanceReminder.vehicleNo')"
                        min-width="120"></el-table-column>
                    <el-table-column prop="VehicleModel" :label="$t('maintenanceReminder.vehicleModel')"
                        min-width="100"></el-table-column>
                    <el-table-column prop="Marker" :label="$t('maintenanceReminder.maintenanceCycle')" min-width="120">
                        <template slot-scope="scope">
                            {{ scope.row.Marker }} km
                        </template>
                    </el-table-column>
                    <el-table-column prop="EMileage" :label="$t('maintenanceReminder.currentMileage')" min-width="120">
                        <template slot-scope="scope">
                            {{ scope.row.EMileage }} km
                        </template>
                    </el-table-column>
                    <el-table-column prop="Parts" :label="$t('maintenanceReminder.maintenanceParts')" min-width="200">
                        <template slot-scope="scope">
                            <!--最多5个，多余5个用...表示-->
                            <el-tag v-for="(part, index) in scope.row.Parts.split(';').slice(0, 5)" :key="index"
                                size="small" style="margin-right: 4px; margin-bottom: 2px;">
                                {{ part }}
                            </el-tag>
                            <!-- 如果有5个以上，显示... -->
                            <span v-if="scope.row.Parts.split(';').length > 5" style="margin-left: 4px;">
                                ...
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="UpdateTime" :label="$t('maintenanceReminder.reminderTime')" min-width="160">
                        <template slot-scope="scope">
                            {{ formatTime(scope.row.UpdateTime) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="IsRead" :label="$t('maintenanceReminder.阅读状态')" width="100" align="center">
                        <template slot-scope="scope">
                            <el-tag :type="scope.row.IsRead === 1 ? 'success' : 'warning'" size="small">
                                {{ scope.row.IsRead === 1 ? $t('maintenanceReminder.已阅') :
                                    $t('maintenanceReminder.未阅') }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('public.Detail')" width="100" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click.stop="showDetailPage(scope.row)">
                                {{ $t('vehicleInfo.view') }}
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <kl-pagination style="margin-bottom: 10px;" :pageSize="PageSize" :total="total"
                    @current-change="pageChange" :current-page.sync="PageNo" @size-change="sizeChange">
                </kl-pagination>
            </el-card>
        </div>

        <!-- 详情弹窗 -->
        <MaintenanceDetailDialog :visible.sync="showDetail" :record="currentRecord" @close="handleDialogClose" />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { formatTime } from "@/utils/longyi";
import { maintanancePatchRead } from '@/http/vehicle'
import MaintenanceDetailDialog from './MaintenanceDetailDialog.vue'

export default {
    name: 'MaintenanceReminderList',
    components: {
        MaintenanceDetailDialog
    },
    data() {
        return {

            searchForm: {
                vehicleNo: '',
                vehicleModel: '',
                readStatus: '0'
            },
            tableData: [],
            loading: false,
            PageNo: 1,
            PageSize: 10,
            total: 0,
            showDetail: false,
            currentRecord: {},
            // 选中的行
            selectedRows: []
        };
    },
    computed: {
        ...mapState({
            selectedVehicles: state => state.app.vehicles.selectedVehicles,
        }),
    },
    mounted() {

        this.handleSearch();
    },
    methods: {
        getSelectedVehicles() {
            let vehicles = "";
            for (let k = 0; k < this.selectedVehicles.length; k++) {
                if (this.selectedVehicles[k].treeLevel == 5) {
                    vehicles = vehicles + this.selectedVehicles[k].nodeValue + ",";
                }
            }
            return vehicles.substring(0, vehicles.length - 1);
        },
        // 处理表格选择变化
        handleSelectionChange(selection) {
            this.selectedRows = selection;
        },
        formatTime(time) {
            return formatTime(time);
        },
        sizeChange(size) {
            this.PageSize = size;
            this.handleSearch();
        },
        // 分页变化
        pageChange(page) {
            this.PageNo = page;
            this.handleSearch();
        },

        handleSearch(isExport) {
            isExport = isExport || 0;
            this.loading = true;
            this.$api.MaintananceSingleReminder({
                Vehicles: this.getSelectedVehicles(),
                VehicleModel: this.searchForm.vehicleModel,
                Language: this.$store.getters.LanguageId,
                PageNo: this.PageNo,
                PageSize: this.PageSize,
                IsExport: isExport,
                IsRead: this.searchForm.readStatus
            }, isExport == 1 ? 'blob' : 'json').then(res => {
                this.loading = false;
                if (isExport == 1) {
                    let blob = new Blob([res], {
                        type: "application/vnd.ms-excel;charset=utf-8",
                    }); // 重点代码

                    let a = document.createElement("a");
                    a.href = window.URL.createObjectURL(blob);
                    a.download = this.$t('maintenanceReminder.维保提醒') + '.xlsx'; // 默认文件名

                    a.click(); // 执行下载
                    window.URL.revokeObjectURL(blob); // 释放ur
                    // window.open(settings.baseUrl + "longyi/xlsx/" + res.data)
                } else {
                    if (res && res.code == 200) {
                        this.tableData = res.data || []
                        this.total = res.count || 0
                    }
                }
            });

        },

        reset() {
            this.searchForm = {
                vehicleNo: '',
                vehicleModel: '',
                readStatus: -1
            };
            this.currentPage = 1;
            this.handleSearch();
        },
        batchMarkAsRead() {

            if (this.selectedRows.length === 0) {
                this.$message.warning(this.$t('maintenanceReminder.请选择需要设置为已读的记录'));
                return;
            }

            // 模拟批量设置为已读操作
            this.loading = true;

            this.$api.maintanancePatchRead({
                "records": this.selectedRows.map(row => ({
                    "vehicleID": row.VehicleID,
                    "marker": row.Marker
                }))
            }).then(res => {
                this.loading = false;

                if (res.code == 200) {
                    this.selectedRows = [];
                    this.$message.success(this.$t('maintenanceReminder.批量设置为已读成功'));
                    this.handleSearch();
                } else {
                    this.$message.error(res.msg || this.$t('maintenanceReminder.批量设置为已读失败'));
                }
            })
        },
        exportData() {
            this.handleSearch(1);
        },


        showDetailPage(row) {
            this.currentRecord = { ...row };
            this.showDetail = true;
        },

        // 处理标记为已读
        handleMarkAsRead(record) {
            const targetRecord = this.tableData.find(r => r.RecordID === record.RecordID);
            if (targetRecord) {
                targetRecord.IsRead = 1;
            }
            this.$message.success(this.$t('maintenanceReminder.markAsReadSuccess'));
        },

        // 处理弹窗关闭
        handleDialogClose() {
            this.currentRecord = {};
        },
    }
};
</script>

<style scoped>
.maintenance-reminder {
    height: 100%;
    padding: 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}

.page-header {
    margin-bottom: 20px;
}

.search-card {
    margin-bottom: 16px;
}

.search-form-inline {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
}

.action-bar {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 16px;
}

.data-card {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.data-card>>>.el-table {
    flex: 1;
    overflow: auto;
}

.pagination-wrapper {
    display: flex;
    justify-content: center;
    padding: 16px 0;
    border-top: 1px solid #ebeef5;
}
</style>